import React from 'react';
import MaterialListItem from '@mui/material/ListItem';
import type {ListItemProps as MaterialListItemProps} from '@mui/material/ListItem';
import {styled} from '@mui/material/styles';

export type ListItemProps = MaterialListItemProps;

const StyledListItem = styled(MaterialListItem)(({theme}) => ({
    '&.Mui-selected': {
        backgroundColor: theme.tokens.FuelColorGreen100
    },
    '&.MuiListItem-root.Mui-selected:active': {
        backgroundColor: theme.tokens.FuelColorGreen100
    }
}));

export const ListItem = React.forwardRef<any, ListItemProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <StyledListItem
                ref={ref}
                {...props}
            >
                {children}
            </StyledListItem>
        );
    });

ListItem.displayName = 'ListItem';
